import framePage from '../framePage';

function showLoading($button) {
	framePage.allowSubmit = false;
	$button.addClass('loading').attr('aria-busy', true);
}

export default showLoading;



// WEBPACK FOOTER //
// ./app/public/src/js/signin/frame/utils/loading/showLoading.js